export default __webpack_public_path__ + "static/media/outro-copy-1.b61483e2.png";